import CommonResources from "./CommonResources";

export default {
  ...CommonResources,
  title: "<b>Zaloguj się</b> i korzystaj z goodie cashback",
  codeDescription: "Kod zaproszenia: ",
  formTitle: "Zaloguj się",
  formTitleModal: "<b>Zaloguj się</b> do goodie",
  formButton: "Loguję się przez {ProviderName}",
  socialButtonsTitle: "lub zaloguj się tak jak lubisz",
  changeScreenButtonText: "Nie masz jeszcze konta?",
  changeScreenButtonLink: "Zarejestruj się",
};
